import { render, staticRenderFns } from "./PricingQuotesCard.vue?vue&type=template&id=6315cba1&scoped=true&"
import script from "./PricingQuotesCard.vue?vue&type=script&lang=js&"
export * from "./PricingQuotesCard.vue?vue&type=script&lang=js&"
import style0 from "./PricingQuotesCard.vue?vue&type=style&index=0&id=6315cba1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6315cba1",
  null
  
)

export default component.exports